// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const DigitalUserOrganization = t.struct({
    id: t.maybe(t.String),
    name: t.maybe(t.String)
}, {
    defaultProps: {
        id: '',
        name: ''
    },
    name: 'DigitalUserOrganization',
    strict: false
});
